module.exports = __webpack_public_path__ + "static/media/day-50-measurements.36d076ff.svg";